import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CustomerAccountBusinessLogicService } from 'src/app/services/customer-account-business-logic.service';
import { RootScopeService } from 'src/app/services/root-scope.service';
import * as Constants from '../../../models/Constants';
import { ApiService } from 'src/app/services/api.service';
import { CallCustomerAttributes } from 'src/app/models/customer.model';

@Component({
  selector: 'app-approved-exception',
  templateUrl: './approved-exception.component.html',
  styleUrls: ['./approved-exception.component.scss'],
})
export class ApprovedExceptionComponent implements OnInit {

  @Output('onChangeCustomerTypeEmitter')
  onChangeCustomerTypeEmitter: EventEmitter<any> = new EventEmitter();
  @Output('goToCustomerOveriew') goToCustomerOveriew: EventEmitter<any> = new EventEmitter();
  errorMsg = Constants.CUSTOMER_TYPE_FAILURE_MSG;
  credentialErrorMsg = Constants.APPROVED_EXCEPTION_CREDENTIAL_CONFIG_MISS_MSG;
  approvedExceptionNotSelected = Constants.APPROVEED_EXCEPTION_NOT_SELECTED_MSG;
  egainContentErrorMsg = Constants.APPROVED_EXCEPTION_EGAIN_CONTENT_CONFIG_MISS_MSG;
  resourceErrorMsg = Constants.RESOURCE_LINKS_CONFIG_MISS_MSG;
  orText = Constants.APPROVED_CREDS.OR_TEXT;
  dependentInfo = Constants.APPROVED_CREDS.DEPENDENT_INFO;

  constructor(
    public rootScope: RootScopeService,
    public customerAccountService: CustomerAccountBusinessLogicService, public apiService: ApiService) { }

  ngOnInit(): void {

  }

  changeCustomerType(event: any) {
    this.onChangeCustomerTypeEmitter.emit(event);

    this.rootScope.activeCustTab.approvedExceptionToggleValue = false;
    this.rootScope.activeCustTab.approvedExceptionSuccessMsg = false;
    this.rootScope.activeCustTab.isApprovedExceptionContinueDisabled = true;
    this.rootScope.activeCustTab.isApprovedExceptionContinueClicked = false;
  }

  /**
   * @author - Sultan Khan
  * Fetches exception and sub-exception data for the active customer tab's type.
  * This method initiates the retrieval of exception and sub-exception data by calling
  * the `getApprovedExceptionsListbyClientId` method from the `customerAccountService`
  */
  getExceptionandSubExceptionType() {
    this.customerAccountService.getApprovedExceptionsListByClientId(this.rootScope.activeCustTab.customerType);
  }

  /**
  * @author - Sultan Khan
 * Handles the change of the selected exception type and updates associated data.
 * This method is triggered when a new exception type is selected. It updates the
 * selected exception type in the active customer tab, clears the selected sub-exception,
 * resets the sub-exceptions list, and updates the form with an empty sub-type value.
 * It also populates the sub-exceptions list based on the selected exception type, if available.
 * 
 * @param event The event containing the newly selected exception type.
 */
  changeExceptionType(event: any) {
    this.rootScope.activeCustTab.approvedExceptionsTypes.selectedException = event?.value;
    this.rootScope.activeCustTab.approvedExceptionsTypes.selectedSubException = '';
    this.rootScope.activeCustTab.approvedExceptionCredentialData.CredentialDataAPIConfigMiss = false;
    this.rootScope.activeCustTab.approvedExceptionCredentialData.CredentialDataAPIFailure = false;
    this.rootScope.activeCustTab.approvedExceptionEgainContentData.EgainContentConfigMiss = false;
    this.rootScope.activeCustTab.approvedExceptionEgainContentData.EgainContentAPIFailure = false;
    this.rootScope.subExceptionsList = [];
    this.rootScope.activeCustTab.approvedExceptionCredentialData.selectedCredentialData = [];
    this.rootScope.activeCustTab.approvedExceptionEgainContentData.selectedEgainContent = '';
    this.rootScope.activeCustTab.approvedExceptionResouceLinksData.selectedResourceLinksData = [];
    this.rootScope.activeCustTab.approvedExceptionResouceLinksData.resourceLinksAPIFailure = false;
    this.rootScope.activeCustTab.approvedExceptionResouceLinksData.resourceLinksConfigMiss = false;
    const customerTypeFilterData = this.rootScope.activeCustTab.approvedExceptionsTypes
      .find((x: any) => x.exceptionsData?.customerType == this.rootScope.activeCustTab.customerType);

    if (customerTypeFilterData) {
      const exceptionFilterData = customerTypeFilterData.exceptionsData.exceptions
        .find((x: any) => x.exception_description == event?.value);
      this.rootScope.subExceptionsList = exceptionFilterData?.exception_subtypes;
    }
    this.rootScope.approvedTypeExceptionForm.patchValue({ subType: '' });

    this.rootScope.activeCustTab.approvedExceptionToggleValue = false;
    this.rootScope.activeCustTab.approvedExceptionSuccessMsg = false;
    this.rootScope.activeCustTab.isApprovedExceptionContinueDisabled = true;
    this.rootScope.activeCustTab.isApprovedExceptionContinueClicked = false;


  }

  /**
 * Handles the change of the selected sub-exception type within the active customer tab.
 * This method is triggered when a new sub-exception type is selected, and it updates the
 * selected sub-exception type in the active customer tab based on the provided event.
 * @param event The event containing the newly selected sub-exception type.
 */
  changeSubExceptionType(event: any): void {
    this.rootScope.activeCustTab.approvedExceptionsTypes.selectedSubException = event?.value;
    const selectedSubExceptionData = this.rootScope.subExceptionsList.find(x => x.exception_subtype_description == event?.value);
    this.customerAccountService.getCredetialData(selectedSubExceptionData);
    this.customerAccountService.getEgainContentData(selectedSubExceptionData);
    this.customerAccountService.getResourseLinks(selectedSubExceptionData);
    this.rootScope.activeCustTab.approvedExceptionToggleValue = false;
    this.rootScope.activeCustTab.approvedExceptionSuccessMsg = false;   
    this.rootScope.activeCustTab.isApprovedExceptionContinueDisabled = true;
    this.rootScope.activeCustTab.isApprovedExceptionContinueClicked = false;
    this.rootScope.is_SecuredMap.set(this.rootScope.activeCustTab?.customerSessionId, selectedSubExceptionData?.is_secured);

  }

  /**
   * Retrieves credential data for the selected sub-exception.
   */
  getCredetialData() {
    const selectedSubExceptionData = this.rootScope.subExceptionsList.find(x => x.exception_subtype == this.rootScope.activeCustTab.approvedExceptionsTypes.selectedSubException);
    this.customerAccountService.getCredetialData(selectedSubExceptionData);
  }

  /**
 * Retrieves Egain data for the selected sub-exception.
 */
  getEgainContentData() {
    const selectedSubExceptionData = this.rootScope.subExceptionsList.find(x => x.exception_subtype == this.rootScope.activeCustTab.approvedExceptionsTypes.selectedSubException);
    this.customerAccountService.getEgainContentData(selectedSubExceptionData);
  }

  /**
* Retrieves Resource Links data for the selected sub-exception.
*/
  getResourceLinksData() {
    const selectedSubExceptionData = this.rootScope.subExceptionsList.find(x => x.exception_subtype == this.rootScope.activeCustTab.approvedExceptionsTypes.selectedSubException);
    this.customerAccountService.getResourseLinks(selectedSubExceptionData);
  }

  onToggleChange(event: any) {
    // alert('Toggle value '+event?.checked  + 'Appro'+ this.rootScope.activeCustTab.isContinueButtonDisabled) ;

    if (event.checked) {
      this.rootScope.activeCustTab.isApprovedExceptionContinueDisabled = false;
      this.rootScope.activeCustTab.approvedExceptionSuccessMsg = true;
      
    }
    else {
      this.rootScope.activeCustTab.isApprovedExceptionContinueDisabled = true;
      this.rootScope.activeCustTab.approvedExceptionSuccessMsg = false;
      this.rootScope.activeCustTab.isApprovedExceptionContinueClicked = false;

    }

  }

  checkApprovedExceptionContinue() {
    return this.rootScope.activeCustTab.isApprovedExceptionContinueDisabled;
  }

  resetApprovedExceptionPage() {
    this.customerAccountService.getExceptionandSubException();
    this.rootScope.activeCustTab.approvedExceptionToggleValue = false;
    this.rootScope.activeCustTab.approvedExceptionSuccessMsg = false;
    this.rootScope.activeCustTab.isApprovedExceptionContinueDisabled = true;
    this.rootScope.activeCustTab.isApprovedExceptionContinueClicked = false;
    window.scrollTo({ top: 0, behavior: 'smooth' });

  }

  isLiveInteraction() {
    if (this.rootScope.activeCustTab.activeCall || this.rootScope.activeCustTab.activeChat) {
      return true;
    }
    else {
      this.rootScope.activeCustTab.approvedExceptionToggleValue = false;
      this.rootScope.activeCustTab.approvedExceptionSuccessMsg = false;
      this.rootScope.activeCustTab.isApprovedExceptionContinueDisabled = true;
      this.rootScope.activeCustTab.isApprovedExceptionContinueClicked = false;

      return false;
    }
  }

  /**
   * Determines whether a link should be enabled based on the provided menu item.
   * @param {any} menu - The menu item to check for link enablement.
   * @returns {boolean} - Returns `true` if the link should be enabled; otherwise, returns `false`.
   */
  enableLink(menu: any): boolean {
    if (menu?.heading === Constants.TBA_KC_ARTICLES_LINKS_TYPES.TBA_EVENTS || menu?.heading === Constants.TBA_KC_ARTICLES_LINKS_TYPES.TBA_INQUIRIES) {
      return !this.rootScope.activeCustTab.isApprovedExceptionContinueClicked;
    }
    return false;
  }

  /**
   * 
   *  when user click on Continue button check isscure value and update in Genesys and store IH data in Tab level
   * @param 
   */
  actionsOnContinue() {
    this.rootScope.activeCustTab.isApprovedExceptionContinueClicked = true;
    this.rootScope.activeCustTab.approvedExceptionSuccessMsg = false;
    
    let approvedDetails = this.rootScope.activeCustTab?.approvedExceptionsTypes;
    // check weather approved expection varible is created in Tab model or not
    if (!(this.rootScope.activeCustTab['approvedExceptionIH'] instanceof Map)) this.rootScope.activeCustTab['approvedExceptionIH'] = new Map();
    this.rootScope.activeCustTab['approvedExceptionIH']?.set(approvedDetails?.selectedException + approvedDetails.selectedSubException, { exceptionType: approvedDetails?.selectedException, subExceptionType: approvedDetails.selectedSubException });
    //this.rootScope.activeCustTab['approvedExceptionIH'].set(approvedDetails?.selectedException ,approvedDetails.selectedSubException);

    if (this.rootScope.is_SecuredMap.get(this.rootScope.activeCustTab?.customerSessionId)) {
      let model = { CS_SECURITY_LEVEL: Constants.securityLevels.SL4, authenticateStatus: Constants.FULLY_SECURED, iconClass: 'green', CP_APPROVED_EXCPTION_SECURED: true, domain: this.goToCustomerOveriew }
      let body: CallCustomerAttributes = {
        attributes: {
          CP_APPROVED_EXCPTION_SECURED: true,
          CS_AUTH_CD:Constants.AuthCode.APE
        },
      };
      this.rootScope.activeCustTab.genesysAttributes.CP_APPROVED_EXCPTION_SECURED = true;
      this.apiService.setAccountSecurityDt(model, body);//update security payloads in genesys and customer account tab values
    }
    

  }
 
   /** function used to check if dependent info is present in credetional details.
   * If Dependent info is present then return true else return false
   * @param elementkey 
   * @returns 
   */
  checkDependentInfoMsg(elementkey){
    if(elementkey?.indexOf(Constants.DEPENDENT_CREDS) != -1 && !this.rootScope.activeCustTab.approvedExceptionCredentialData.isDependentInfoMsgShown){
      this.rootScope.activeCustTab.approvedExceptionCredentialData.isDependentInfoMsgShown=true;
      return true;
    }  
    else{
      this.rootScope.activeCustTab.approvedExceptionCredentialData.isDependentInfoMsgShown=false;
      return false;
    }
    
    }

    checkORTextApprovedException(elementkey){
      this.rootScope.activeCustTab.approvedExceptionCredentialData.isORText = false;
      if(this.rootScope.activeCustTab.approvedExceptionCredentialData?.prevkey?.includes(Constants.APPROVED_CREDS.NATIONAL) &&  elementkey?.includes(Constants.APPROVED_CREDS.BIRTH) && 
      this.rootScope?.activeCustTab?.approvedExceptionsTypes?.selectedException?.includes(Constants.APPROVED_CREDS.EXCEPTION_DEATH)
      && this.rootScope?.activeCustTab?.approvedExceptionsTypes?.selectedSubException?.includes(Constants.APPROVED_CREDS.SUBEXCEPTION_ACC_DEATH)
      ){
        this.rootScope.activeCustTab.approvedExceptionCredentialData.prevkey = elementkey;
        this.rootScope.activeCustTab.approvedExceptionCredentialData.isORText =true;
        return true;
      }
      this.rootScope.activeCustTab.approvedExceptionCredentialData.prevkey = elementkey;
      return false;
    }

    checkforEmptyCredValues(values){
      //console.log('Values' + values);
       if (values?.length == 0){
          return true;
        }
        else if(values?.length >= 1 && (values[0]?.value == 'NA' || values[0]?.value == '')){
          return true;
        }
      
      return false;
    }

}
